// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"508bb2d1e43d38e3d1c9","147":"f55be5a893ffb1f2677f","251":"5200d5bfbeac0fae44dd","352":"8feb64d57a07be739c05","550":"b011e4abbc8967a4f77d"}[chunkId] + ".js";
};